module.exports = __webpack_public_path__ + "img/logo-rtl-dark.aaced23e.svg";